/**
 * TypeScript interface for InventAuctionDTO from the C# API
 */
export interface InventAuction {
  id: string; // Guid in C# maps to string in TypeScript
  title: string;
  dateTime: Date | null;
  endDateTime: Date | null;
  activityStatus: number;
  activityStatusText: string;
  auctionTypeTitle: string;
  auctionLocationId: number;
  auctionLocationTitle: string;
  lotsCount: number;
}

/**
 * Enum for auction activity status
 * Matches the C# implementation
 */
export enum AuctionActivityStatus {
  Unknown = 0,
  Upcoming = 1,
  InProgress = 2,
  Paused = 3,
  Finished = 4,
  Closed = 5
}

/**
 * Helper function to get activity status text from status code
 * Matches the C# implementation
 */
export function getActivityStatusText(status: number): string {
  switch (status) {
    case AuctionActivityStatus.Upcoming:
      return 'Upcoming';
    case AuctionActivityStatus.InProgress:
      return 'In-Progress';
    case AuctionActivityStatus.Paused:
      return 'Paused';
    case AuctionActivityStatus.Finished:
      return 'Finished';
    case AuctionActivityStatus.Closed:
      return 'Closed';
    default:
      return 'Unknown';
  }
}
